import { KvittensSession } from "@/store/types";
import { kvittensSessionKey } from "@/constants";
import { SessionServiceInterface } from "@/services/SessionService/SessionServiceInterface";

class SessionServiceImpl implements SessionServiceInterface {
    public getKvittensSession(): null | KvittensSession {
        const session = sessionStorage.getItem(kvittensSessionKey);
        if (session) {
            return JSON.parse(session) as KvittensSession;
        }
        return null;
    }
}

export const SessionService = new SessionServiceImpl();
